// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"88154649","624":"57dbe3c8"}[chunkId] + ".chunk.js";
};